export class SearchTypeFieldBus 
{
    searchTypeFieldId: any;
    searchTypeId: any;
    fieldName: string;
    fieldIdName: string;
    hidden: Boolean;
    fieldType: string;
    title: string;
    columnClass: string;
    headerClass: string;
    media: string;
    format: string;
    isDataColumn: Boolean;
    isKey: Boolean;
    colOrder: number;
    dataName: string;
    active: boolean;
    width: number;
    filterType: string;
}
